import React from 'react';
import cl from './AboutInfo.module.css';

import company from '../../../image/what-is-a-startup-6-min.jpg';

const AboutInfo = (props) => {
  return (
    <section className={cl.about}>
      <div className={cl.about_content}>
        <h1>About our company</h1>
        <img alt="about" className={cl.big_image} src={company} />
        <p>{props.shopStory}</p>
      </div>
    </section>
  );
};

export default AboutInfo;
